import React, { Component } from 'react';
import { Col, FormGroup, Row } from 'reactstrap';
import Select from 'react-select';
import HtmlHelpers from '../../HtmlHelpers';
const filterOption = (option, inputValue) => (option.label.toString().toLowerCase().match(inputValue.toLowerCase()) || []).length > 0;
export default class WmDropdown extends Component {
  constructor() {
    super(...arguments);
    this.onChange = selected => {
      const value = {
        target: {
          name: this.props.name,
          value: selected
        }
      };
      if (this.props.additionalInfo !== undefined) {
        this.props.onChange(value, this.props.additionalInfo);
      } else {
        this.props.onChange(value);
      }
    };
    this.getDropdownOnly = () => this.props.dropdownOnly || false;
    this.getOptions = () => this.props.isRequired ? this.optionsWithBlank() : this.props.options;
    this.getPlaceholder = () => this.props.placeholder || 'Select...';
    this.optionsWithBlank = () => [{
      label: '',
      value: ''
    }] + this.props.options;
    this.getStyles = () => this.props.styles || {};
    this.isSearchable = () => this.props.isSearchable === false ? false : true;
    this.maxMenuHeight = () => this.props.maxMenuHeight || 300;
    this.getDropdown = () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, {
      name: this.props.name,
      required: this.props.isRequired,
      value: this.props.values,
      onChange: this.onChange,
      options: this.props.options,
      placeholder: this.getPlaceholder(),
      isMulti: this.props.multi,
      isDisabled: this.props.disabled,
      isClearable: true,
      className: "text-left",
      filterOption: filterOption,
      isSearchable: this.isSearchable(),
      maxMenuHeight: this.maxMenuHeight(),
      styles: this.getStyles()
    }), /*#__PURE__*/React.createElement("div", {
      className: "invalid-feedback"
    }));
  }
  render() {
    return this.getDropdownOnly() ? this.getDropdown() : /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Row, {
      className: "align-items-center"
    }, HtmlHelpers.getWmLabel(this.props), /*#__PURE__*/React.createElement(Col, {
      md: this.props.fieldColumns
    }, this.getDropdown()), "\xA0", this.props.buttonAfter));
  }
}
WmDropdown.defaultProps = {
  isRequired: false,
  multi: false
};